<template>
	<div class="card-main1"
		:style="{ width: cardWidth, height: cardHeight,'min-width':minWidth,'min-height':minHeight,'max-width':maxWidth,'max-height':maxHeight }">
		<div class="card-top">
			<!-- 修改1：支持自定义标题插槽，如果提供了就使用，否则显示默认标题 -->
			<slot name="card-title" v-if="$slots['card-title'] || $scopedSlots['card-title']">
				<!-- 默认显示 -->
				<div class="card-titlecard-title">{{ title }}</div>
			</slot>
			<div v-else class="card-title">{{ title }}</div>
			
			<div class="card-more" :style="{ justifyContent: toolJustifyontent, display: 'flex', alignItems: 'center', gap: '8px'}">
				<slot name="card-tool"></slot>
				<i class="el-icon-more"></i>
			</div>
		</div>


		<div class="card-box1" v-if="hasBox1Content">
		<slot name="card-box1"></slot>
		</div>		

		<div class="card-box2" v-if="hasBox2Content">
		<slot name="card-box2"></slot>
		</div>	

		<!-- 新增：中间行 - 筛选框区域（默认不显示） -->
		<div class="card-filter" v-if="showFilter && hasFilterContent">
			<slot name="card-filter">
				<!-- 默认筛选框插槽，可被父组件覆盖 -->
				<div class="default-filter">
					<!-- 这里可以放置默认的筛选组件 -->
					<!-- 例如：<el-input placeholder="请输入筛选条件" /> -->
				</div>
			</slot>
		</div>

		<div class="card-box">
			<slot name="card-box"></slot>
			<!--<card-table></card-table>-->
		</div>
	</div>
</template>

<script>
	export default {
		name: 'card-M1',
		props: {
			title: {
				type: String,
				required: false,
				default: ''
			},
			cardWidth: {
				type: String,
				required: false,
				default: '47%'
			},
			cardHeight: {
				type: String,
				required: false,
				default: '45vh'
			},
			// minWidth: {
			// 	type: String,
			// 	required: false,
			// 	default: '440px'
			// },
			minHeight: {
				type: String,
				required: false,
				default: '325px'
			},
			maxWidth: {
				type: String,
				required: false,
				default: ''
			},
			toolWidth: {
				type: String,
				required: false,
				default: ''
			},
			toolJustifyontent: {
				type: String,
				required: false,
				default: 'space-around'
			},
			maxHeight: {
				type: String,
				required: false,
				default: '450px'
			},
			showSearch: {
				type: Boolean,
				required: false,
				default:false
			},
	
			placeholder: {
				type: String,
				required: false,
			},
			// 修改：新增 showFilter 属性，控制是否显示筛选区域
			showFilter: {
				type: Boolean,
				required: false,
				default: false  // 默认不显示筛选区域
			},
		},
		data() {
			return {
				default_placeholder: this.placeholder ? this.placeholder : "请输入内容",
			}},
		computed: {
			// 计算是否有筛选内容：如果插槽有内容，才显示筛选区域
			hasFilterContent() {
				// 检查 card-filter 插槽是否有内容
				return !!this.$slots['card-filter'] || 
					   !!this.$scopedSlots['card-filter'] ||
					   // 如果父组件没有提供插槽内容，但 showFilter 为 true 且我们希望显示默认内容
					   (this.showFilter && this.hasDefaultFilter());
			},

			// 【新增】计算是否有 card-box1 插槽内容
			hasBox1Content() {
				return !!this.$slots['card-box1'] || !!this.$scopedSlots['card-box1'];
			},			
			// 【新增】计算是否有 card-box1 插槽内容
			hasBox2Content() {
				return !!this.$slots['card-box2'] || !!this.$scopedSlots['card-box2'];
			}
		},

		methods: {
			search(data){
				this.$emit("search",data)
			}
		}
	};
</script>

<style scoped lang="scss">
	.card-main1 {
		/* 卡片 */
		position: relative;
		background: rgb(255, 255, 255);
		box-sizing: border-box;
		margin-bottom: 20px;
		margin-right: 20px;
		padding: 10px;
		// padding-top: 15px;
		// padding-bottom: 15px;
		// padding-right: 15px;
		// padding-left: 5px;
		box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
		border-radius: 10px;
		display: flex;
		flex-direction: column;
	}

	.card-top {
		display: flex;
		align-items: center;
		width: 100%;
		justify-content: space-between;
		margin-bottom: 5px;
		// background: rgb(255, 255, 0);

		.card-title {
			position: relative;
			color: rgb(128, 128, 128);
			font-family: Microsoft YaHei;
			font-size: 20px;
			font-weight: 700;
			line-height: 22px;
			letter-spacing: 1px;
			text-align: left;
			min-width: 30%;

		}

		.card-tool {
			display: flex;
			justify-content: space-around;
			margin-right: 20px;
			font-size: 14px;
		}
	}

	/* 新增：筛选区域样式 */
	.card-filter {
		margin: 0px 0;
		padding: 0 0;
		// border-top: 1px solid #e0e0e0;
		// border-bottom: 1px solid #e0e0e0;
		// background: rgb(200, 255, 200); /* 测试背景色，可移除 */
		
		.default-filter {
			display: flex;
			gap: 10px;
			align-items: center;
		}
	}
	
	.card-box1 {
		max-height: 150px;
		position: relative;
		// display: flex;
	}

	.card-box2 {
		max-height: 230px;
		position: relative;
		// display: flex;
	}
	.card-box {
		height: 100%;
		
		// min-height: 60vh;
		padding: 5px 5px 5px 5px;
		position: relative;
		// display: flex;
	}

@media screen and (max-width: 768px) {
  .card-main1 {
	margin-bottom: 0 !important;
	margin-right: 0 !important;
    .card-box2 {
      flex-direction: column;
      height: auto;
      gap: 16px;
      height: 330px;
    }
  }

  .card-top {
    margin-bottom: 0px;
  }

  .card-top .card-title {
    font-size: 14px !important;
    line-height: 18px !important;
  }

  .card-more {
    gap: 2px !important;
    font-size: 11px !important;
  }

  .card-more i {
    font-size: 14px !important;
  }

  .card-box {
    padding: 2px !important;
  }
}

</style>